import { NoInputType } from '../InputTypes';
import { makeOperator } from './Operator';
export const name = 'MissingAssociationBranchFilter';
export default makeOperator({
  inputType: NoInputType,
  name,
  values: [{
    name: 'value',
    isValid: value => typeof value === 'object' && value !== null
  }]
});